// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AB7d","type":"styles_type__2DmUJ","choices":"styles_choices__zNGWf"};